
// social
(function(){
  var nowh=window.location.href;
  var head=$($("h1")[0]).html().replace('%','%25');
  $(".social .facebook").click(function(){
      window.open("https://www.facebook.com/sharer.php?u="+nowh)
  });
  $(".social .reddit").click(function(){
      window.open("https://www.reddit.com/submit?url="+nowh+"&title="+document.title)
  });
  $(".social .twitter").click(function(){
      window.open("https://twitter.com/intent/tweet?text="+head+" "+nowh)
  });
  $(".social .linkedin").click(function(){
      window.open("https://www.linkedin.com/shareArticle?mini=true&url="+nowh+"&title="+document.title)
  });
  })();
  
 
  
  // 左侧目录点击展开或者加active状态
  (function(){
      var isUserClick = false; 
  
      $('.catalog li').click(function(event) {
          var index = $(this).index(); 
          var target = $('.text_content h2').eq(index);
      
          isUserClick = true;
      
          $('html, body').animate({
              scrollTop: target.offset().top - 120
          }, 500, function() {
              isUserClick = false;
          }); 
      
          $(this).addClass('active').siblings().removeClass('active');
      
          event.stopPropagation();
      });
      
      $(window).scroll(function() {
          if (!isUserClick) {
              var scrollTop = $(window).scrollTop();
              var text_content = $('.text_content');
              var text_content_h2 = text_content.find('h2');
          
              text_content_h2.each(function(index, element) {
                  var h2_top = $(element).offset().top;
                  var h2_bottom = h2_top + $(element).outerHeight();
          
                  if (scrollTop >= h2_top - 120 && scrollTop < h2_bottom - 120) {
                      $('.catalog li').eq(index).addClass('active').siblings().removeClass('active');
                  }
              });
          }
      });
  })();
  
  
  